import { sendBeacon } from "@helpers/webBeacon"
import { route } from "ziggy-js"
import {
  currentInteractionPlatform,
  InteractionType,
} from "@shared/models/Interaction/Interaction"

interface SendInteractionParams {
  productId: string
  collectionId?: string
  type: InteractionType
  tag?: string
}

export const sendInteraction = ({ productId, collectionId, type, tag }: SendInteractionParams) => {
  const data = new window.FormData()
  data.append("product_id", productId)
  if (collectionId) {
    data.append("collection_id", collectionId)
  }
  data.append("type", type)
  data.append("platform", currentInteractionPlatform)
  if (tag) {
    data.append("tag", tag)
  }
  data.append("subject", "Product")

  sendBeacon(route("merchant.interactions.store"), data)
}
